/**
 * Runtime configuration, read from CRA environment variables at build time.
 *
 * The Web3Forms access key is not a secret -- it ships in the public JS bundle
 * by design, and Web3Forms' own examples put it directly in HTML. It lives here
 * so that development and production can use different keys: the live key is
 * restricted to thelpacompany.com, which means it cannot be used from
 * localhost, so local work needs a separate unrestricted key.
 *
 * Set it in .env.development (local) and .env.production (deployed build).
 */

export const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_KEY || '';

if (!WEB3FORMS_ACCESS_KEY) {
  // Without a key every submission is rejected by Web3Forms, and a client
  // enquiry disappears. Fail loudly rather than quietly.
  // eslint-disable-next-line no-console
  console.error(
    'REACT_APP_WEB3FORMS_KEY is not set. Form submissions will fail. ' +
      'Check .env.development / .env.production.'
  );
}
